// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"996f3fff","198":"a7b7c899","272":"b134ca95","486":"9a62c8cf","627":"08de87c0","856":"7f4e206c"}[chunkId] + ".chunk.js";
};